import { render, staticRenderFns } from "./ChinaCityMobile.vue?vue&type=template&id=6dbfe8a0&scoped=true"
import script from "./ChinaCityMobile.vue?vue&type=script&lang=js"
export * from "./ChinaCityMobile.vue?vue&type=script&lang=js"
import style0 from "./ChinaCityMobile.vue?vue&type=style&index=0&id=6dbfe8a0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbfe8a0",
  null
  
)

export default component.exports